/* global gtag */
import React, { useEffect, useState, useMemo, useRef } from "react";
import { Input, Label, FormGroup, Form } from "reactstrap";
import { Modal, ModalBody, ModalFooter } from "reactstrap";
import { MakeAnOffer, getUserbyEmail, postOrder } from "../Data";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import PlaceHolder from "../../../assets/images/Placeholder.png";
import "./Modal.css";
import Select from "react-select";
import { FaForward, FaQuestionCircle, FaUserAlt } from "react-icons/fa";
import CustomerAvaliableCalander from "../CustomerAvaliableCalander";
import Payment from "../../../pages/DashboardPages/settingsComponents/Payment";
import {
  setMakeOfferStatus,
  setOrderId,
} from "../../../redux/slices/RequestFormSlice";
import { fetchMyservices } from "../../../redux/slices/bwvSlice";
import CustomButton from "../../CustomButton";

const MakeOfferModal = ({
  isOpen,
  closeModal,
  selectedCard,
  setSchedule,
  schedule,
  timeLeft,
}) => {
  const isProd = process.env.REACT_APP_PRODUCTION === "true";
  const navigate = useNavigate();
  const islogin = useSelector((state) => state.user.isLogin);
  const userinfo = useSelector((state) => state.user.userInfo);
  const user = islogin ? JSON.parse(userinfo) : null;
  const [message, setMessage] = useState("");
  const [budget, setBudget] = useState("");
  const [reserveDate, setReserveDate] = useState("");
  const [startTime, setStartTime] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState(null);
  const [userByEmail, setUserByemail] = useState([]);
  const [service, setService] = useState(null);
  const [showPayment, setShowPayment] = useState(false);
  const logUser = user?.Role;
  // const logUser = localStorage.getItem("USER_ROLE");
  const custTimeZone = selectedCard?.customerTimezone;
  const providerTimeZone = userByEmail[0]?.TimeZone || "PST";
  const isAdmin = user && user.Role === "admin";
  const isCustomer = user && user.Role === "customer";
  const dispatch = useDispatch();
  const { makeOfferStatus } = useSelector((state) => state.requestForm);
  const { myServices2 } = useSelector((state) => state.bwvData);
  const isFetching = useRef(false);
  const [searchText, setSearchText] = useState(""); // State for search input
  const fetchData = async () => {
    if (user && !isFetching.current) {
      isFetching.current = true; // Prevent multiple calls
      const serviceParams = {
        pageId: 1,
        pageSize: 20,
        postStatus: 3,
        searchText: searchText || undefined, // Pass searchText
      };
      Promise.all([dispatch(fetchMyservices(serviceParams))]).finally(() => {
        isFetching.current = false; // Reset fetching flag
      });
    }
  };
  const handleClose = () => {
    closeModal();
    setSearchText("");
    setBudget("");
    setMessage("");
    setReserveDate("");
    setStartTime("");
    setService(null);
  };

  useEffect(() => {
    fetchData();
  }, [isOpen, searchText]); // Trigger fetchData when searchText changes

  // Fetch user by email
  useEffect(() => {
    const fetchUserByEmail = async () => {
      try {
        const data = await getUserbyEmail(user?.Email);
        setUserByemail(data);
        setErrors(null);
      } catch (err) {
        console.error("Error fetching user by email:", err);
        setErrors("Failed to load user data. Please try again.");
      }
    };
    if (user?.Email) {
      fetchUserByEmail();
    }
  }, [user?.Email]);

  // Reset state when selectedCard changes
  useEffect(() => {
    setBudget("");
    setMessage("");
    setReserveDate("");
    setStartTime("");
    setService(null);
  }, [selectedCard]);

  // Handle offer submission
  const handleMakeOffer = async () => {
    if (isLoading) return;
    if (!budget || budget == 0) {
      toast.error("Enter valid Price");
      return;
    }
    if (!message) {
      toast.error("Enter Message");
      return;
    }
    if (schedule && !reserveDate) {
      toast.error("Select Reserve Date");
      return;
    }
    if (schedule && !startTime) {
      toast.error("Select Start Time");
      return;
    }
    if (isAdmin && !service) {
      toast.error("Select a Service Provider");
      return;
    }

    const messageForm = {
      customerId: selectedCard?.createdBy,
      postId: selectedCard?.Id,
      postType: 3,
      Description: message,
      messageStatus: 1,
      createdBy: isAdmin && service ? Number(service.createdBy) : user?.UserID,
      roleId: isAdmin && service ? 2 : user?.RoleId,
      ownerId: selectedCard?.createdBy,
      userName:
        isAdmin && service
          ? service.userName?.split("@")[0]?.trim()
          : user?.UserName?.split("@")[0]?.trim(),
      Email: isAdmin && service ? service.Email : user?.Email,
      serviceNeed: "need",
      Budget: parseFloat(budget),
      needId: selectedCard?.Id,
      needName: selectedCard?.Title,
      startTime: startTime,
      reserveDate: reserveDate,
      providerTimezone: providerTimeZone,
      customerTimezone: custTimeZone,
      zoomStatus: startTime ? 1 : 0,
      zoomRole:
        (startTime &&
          (isAdmin && service ? service.createdBy : user?.UserID)) ||
        null,
      gottenWithinTime: timeLeft === "00:00:00" ? 0 : 1,
    };

    setIsLoading(true);
    try {
      await MakeAnOffer(messageForm);
      toast.success("Offer sent to Admin for Approval");
      console.log(window.dataLayer, " window.dataLayer");
      if (isProd && window.dataLayer) {
        window.dataLayer.push({
          event: "offer_sent",
          method: "make_offer",
          ad_id: selectedCard?.Id,
        });
      }
      handleClose();
    } catch (err) {
      console.error("Error sending offer:", err);
      toast.error("Failed to send offer. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  // Handle 24-hour offer with payment
  const handle24hrOffer = async () => {
    if (!budget || budget == 0) {
      toast.error("Enter valid Price");
      return;
    }
    if (!message) {
      toast.error("Enter Message");
      return;
    }
    if (schedule && !reserveDate) {
      toast.error("Select Reserve Date");
      return;
    }
    if (schedule && !startTime) {
      toast.error("Select Start Time");
      return;
    }
    if (isAdmin && !service) {
      toast.error("Select a Service Provider");
      return;
    }

    const formData = {
      customerId: selectedCard?.createdBy,
      createdBy: user?.UserID,
      totalAmount: 10,
      orderStatus: "PENDING",
    };

    try {
      const order = await postOrder(formData);
      dispatch(setOrderId(order?.Id));
      setShowPayment(true);
    } catch (err) {
      console.error("Error creating order:", err);
      toast.error("Failed to create order. Please try again.");
    }
  };

  // Handle payment completion
  useEffect(() => {
    if (makeOfferStatus === "COMPLETED") {
      handleMakeOffer();
      dispatch(setMakeOfferStatus(""));
    }
  }, [makeOfferStatus]);

  // Handle budget input
  const handleBudget = (e) => {
    let value = e.target.value.replace(/[^0-9.]/g, "");
    const decimalCount = (value.match(/\./g) || []).length;
    if (decimalCount > 1) {
      value = value.substring(0, value.lastIndexOf("."));
    }
    const parts = value.split(".");
    if (parts.length > 1) {
      parts[1] = parts[1].slice(0, 2);
      value = parts.join(".");
    }
    setBudget(value);
  };

  // Parse availability
  let parsedAvailability = [];
  if (selectedCard && typeof selectedCard.availableFrom === "string") {
    try {
      parsedAvailability = JSON.parse(selectedCard.availableFrom);
    } catch (error) {
      console.error("Error parsing selectedCard.availableFrom:", error);
    }
  }

  // Compute select options
  const options = useMemo(
    () =>
      myServices2
        ?.map((list) => ({
          value: JSON.stringify(list),
          label: `${list.Title} ${list.firstName || ""} ${list.lastName || ""}`,
        }))
        .sort((a, b) => a.label.localeCompare(b.label)) || [],
    [myServices2]
  );

  // Convert time to 12-hour format
  const convertTo12Hour = (time) => {
    if (typeof time !== "string") return "";
    const [hours, minutes] = time.split(":");
    const suffix = hours >= 12 ? "PM" : "AM";
    const adjustedHours = hours % 12 || 12;
    return `${adjustedHours}:${minutes} ${suffix}`;
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={handleClose}
      className="hire-modal modal-content"
      size="lg"
    >
      <div
        className="d-flex justify-content-end"
        style={{ margin: "20px 32px 0 0" }}
      >
        <button type="button" className="btn-close" onClick={handleClose} />
      </div>
      <ModalBody className="px-5 py-3">
        {errors && (
          <p style={{ color: "red", marginBottom: "10px" }}>{errors}</p>
        )}
        <div className="d-flex flex-row align-items-center pb-3">
          <div style={{ width: "50px", height: "50px", marginRight: "30px" }}>
            <img
              src={selectedCard?.profilePhoto || PlaceHolder}
              style={{ height: "100%", width: "100%", borderRadius: "50%" }}
              alt="Profile"
            />
          </div>
          <div>
            <h5>{selectedCard?.FullName || ""}</h5>
          </div>
        </div>
        {isCustomer ? (
          <div className="p-3 my-2 text-center">
            <h6 className="mb-3">
              Become a Service Provider to offer your services
            </h6>
            <p className="mx-5 my-2 text-center fw-bold ">
              Go to Dashboard → Click on My Services for Sale → Create Service
            </p>
            <CustomButton
              onClick={() => navigate("/dashboardpage")}
              type="default"
              icon={FaForward}
              title="Go to Dashboard"
              className=""
            >
              Go to Dashboard
            </CustomButton>
            {/* <button
              type="button"
              className="btn btn-primary mt-2"
              onClick={() => navigate("/dashboardpage")}
            >
              Go to Dashboard
            </button> */}
          </div>
        ) : (
          <Form>
            {logUser === "admin" && (
              <FormGroup>
                <Label for="provider">Providers</Label>
                <Select
                  options={options}
                  onChange={(selectedOption) =>
                    setService(
                      selectedOption ? JSON.parse(selectedOption.value) : null
                    )
                  }
                  onInputChange={(inputValue) => setSearchText(inputValue)} // Capture search input
                  placeholder="Select Service Provider"
                  isSearchable
                  isClearable
                />
              </FormGroup>
            )}
            <FormGroup>
              <Label>
                Package Price <b className="text-danger">*</b>
              </Label>
              <Input
                type="text"
                name="Budget"
                placeholder="$0.00"
                value={budget ? `$${budget}` : ""}
                onChange={handleBudget}
              />
            </FormGroup>
            <FormGroup>
              <Label>
                Make a Warm Introduction <b className="text-danger">*</b>{" "}
                <FaQuestionCircle
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Please list all services included for the price otherwise the offer may not be approved and sent to the customer"
                />
              </Label>
              <Input
                type="textarea"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Details of the items included in the package..."
                maxLength={655}
              />
            </FormGroup>
            <FormGroup className="d-flex flex-row">
              <Input
                type="checkbox"
                checked={schedule}
                onChange={() => {
                  setSchedule(!schedule);
                  setReserveDate("");
                  setStartTime("");
                }}
              />{" "}
              <Label>Schedule Zoom Call</Label>
            </FormGroup>
            {schedule && (
              <>
                <span>
                  <small>
                    <b>
                      Please schedule the call using the tool below within the
                      Customer's mentioned availability schedule.
                    </b>
                  </small>
                </span>
                <p className="py-2">
                  <b className="text-black">Note: </b> All the scheduled calls
                  are set to the default PST timezone. If necessary, please go
                  to the Profile section to change the timezone
                </p>
                {parsedAvailability.length > 0 && (
                  <CustomerAvaliableCalander
                    reserveDate={reserveDate}
                    startTime={startTime}
                    setReserveDate={setReserveDate}
                    setStartTime={setStartTime}
                    availableDays={parsedAvailability}
                    ownerId={selectedCard?.createdBy}
                  />
                )}
                {startTime && (
                  <p>
                    <small>
                      The Calls will be scheduled for 30 min starting from{" "}
                      {convertTo12Hour(startTime)}
                    </small>
                  </p>
                )}
              </>
            )}
            {showPayment && (
              <>
                <h5 className="text-center">Late Fee $10 Applicable</h5>
                <div
                  style={{ width: "60%", margin: "auto" }}
                >
                  <Payment
                    totalPrice={10}
                    state={{ makeOfferPay: true }}
                    chatDetails={true}
                  />
                </div>
              </>
            )}
            {!showPayment && (
              <ModalFooter className="px-0" style={{ border: "none" }}>
                {/* <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => {
                    if (isAdmin || timeLeft !== "00:00:00") {
                      handleMakeOffer();
                    } else {
                      handle24hrOffer();
                    }
                  }}
                  disabled={isLoading}
                >
                  {isLoading ? "Sending..." : "Get Customer!"}
                </button> */}
                <CustomButton
                  onClick={() => {
                    if (isAdmin || timeLeft !== "00:00:00") {
                      handleMakeOffer();
                    } else {
                      handle24hrOffer();
                    }
                  }}
                  type="default"
                  icon={FaUserAlt}
                  title="Get Customer"
                  className=""
                >
                  {isLoading ? "Sending..." : "Get Customer!"}
                </CustomButton>
              </ModalFooter>
            )}
          </Form>
        )}
      </ModalBody>
    </Modal>
  );
};

export default MakeOfferModal;
